import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { ChipContent } from 'src/app/shared/models/chip-content/chip-content';
import { ChipContentOption } from 'src/app/shared/models/chip-content/chip-content-option';
import { FilterType } from 'src/app/shared/models/constants/filter-type';

@Component({
  selector: 'app-filter-area',
  templateUrl: './filter-area.component.html',
  styleUrls: ['./filter-area.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Filter Area Organism
 */
export class FilterAreaComponent implements OnInit {
  @Input() isCarousel: boolean = true;
  @Input() chipContents!: ChipContent[];
  @Input() isGray: boolean = false;
  @Input() isGrayBlue: boolean = false;

  @Input() customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    margin: 5,
    responsive: {
      0: {
        items: 3,
      },
      480: {
        items: 4,
      },
    },
    stagePadding: 20,
    navText: ['', ''],
    nav: false,
    autoWidth: true,
  };
  @Output() selectedFilter = new EventEmitter<ChipContent>();
  @Output() selectedOption = new EventEmitter<ChipContentOption>();

  /**
   * @constructor
   */
  constructor(private translationService: TranslationService) {}

  /**
   * ngOnInit()
   */
  ngOnInit(): void {
    this.translationService.translateChipContentArray(this.chipContents);
  }

  /**
   * Selects and emit the filter
   * @param {ChipContent} element
   */
  selectFilter(element: ChipContent) {
    this.selectedFilter.emit(element);
  }

  /**
   * Select chip option
   * @param {ChipContentOption} event
   * @param {ChipContent} element
   */
  selectChipOption(event: ChipContentOption, element: ChipContent) {
    element.value = event.text;
    this.selectedOption.emit(event);
  }

  /**
   * returns if is sort by
   * @param {ChipContent} element
   * @return {boolean}
   */
  isSort(element: ChipContent): boolean {
    return (
      element.filterType === FilterType.REWARDS_SORT_BY ||
      element.filterType === FilterType.BUSINESS_SORT_BY
    );
  }
}
